export class SetCurrentPhotos {
	static readonly type = '[Quality][PhotoReview] SetCurrentPhotos';
	constructor(public photo: any) {}
}
